var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "b-card",
        [
          _c(
            "b-card-body",
            [
              _c(
                "b-row",
                { staticClass: "justify-content-between" },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "mb-2 text-right",
                          attrs: { cols: "12" },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "outline-danger", size: "sm" },
                              on: { click: _vm.clearFilters },
                            },
                            [_vm._v(" Clear Filters ")]
                          ),
                        ],
                        1
                      ),
                      !_vm.mainLoading
                        ? _c("b-table", {
                            attrs: {
                              striped: "",
                              hover: "",
                              responsive: "",
                              "per-page": _vm.perPage,
                              "current-page": _vm.currentPage,
                              items: _vm.filteredTimesheets(),
                              fields: _vm.timesheet_fields,
                              "sort-by": _vm.sortBy,
                              "sort-desc": _vm.sortDesc,
                              "sort-direction": _vm.sortDirection,
                            },
                            on: {
                              "update:sortBy": function ($event) {
                                _vm.sortBy = $event
                              },
                              "update:sort-by": function ($event) {
                                _vm.sortBy = $event
                              },
                              "update:sortDesc": function ($event) {
                                _vm.sortDesc = $event
                              },
                              "update:sort-desc": function ($event) {
                                _vm.sortDesc = $event
                              },
                              filtered: _vm.onFiltered,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "head(employeeName)",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "d-flex flex-column" },
                                        [
                                          _c("span", [_vm._v("Employee")]),
                                          _c("b-form-input", {
                                            staticClass: "mt-1",
                                            attrs: {
                                              placeholder: "Filter by Name",
                                              size: "sm",
                                            },
                                            model: {
                                              value: _vm.filters.employeeName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "employeeName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "filters.employeeName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "head(moduleType)",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "d-flex flex-column" },
                                        [
                                          _c("span", [_vm._v("Module")]),
                                          _c("b-form-select", {
                                            staticClass: "mt-1",
                                            attrs: {
                                              options: [
                                                { value: null, text: "All" },
                                              ].concat(_vm.timesheetModules),
                                              size: "sm",
                                            },
                                            model: {
                                              value: _vm.filters.module,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "module",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.module",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "head(hoursWorked)",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "d-flex flex-column" },
                                        [
                                          _c("span", [_vm._v("Total Hours")]),
                                          _c("b-form-input", {
                                            staticClass: "mt-1",
                                            attrs: {
                                              placeholder: "Filter by Hours",
                                              size: "sm",
                                            },
                                            model: {
                                              value: _vm.filters.hoursWorked,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "hoursWorked",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.hoursWorked",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "head(status)",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "d-flex flex-column" },
                                        [
                                          _c("span", [_vm._v("Status")]),
                                          _c(
                                            "b-form-select",
                                            {
                                              staticClass: "mt-1",
                                              attrs: { size: "sm" },
                                              model: {
                                                value: _vm.filters.status,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.filters,
                                                    "status",
                                                    $$v
                                                  )
                                                },
                                                expression: "filters.status",
                                              },
                                            },
                                            [
                                              _c(
                                                "option",
                                                { domProps: { value: null } },
                                                [_vm._v("All")]
                                              ),
                                              _vm._l(
                                                _vm.timesheetStatus,
                                                function (status) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      key: status.value,
                                                      domProps: {
                                                        value: status.value,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(status.text) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "head(taskDescription)",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "d-flex flex-column" },
                                        [
                                          _c("span", [_vm._v("Comment")]),
                                          _c("b-form-input", {
                                            staticClass: "mt-1",
                                            attrs: {
                                              placeholder: "Filter by Comment",
                                              size: "sm",
                                            },
                                            model: {
                                              value:
                                                _vm.filters.taskDescription,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "taskDescription",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "filters.taskDescription",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "head(date)",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex flex-column date-filter-container",
                                        },
                                        [
                                          _c("span", [_vm._v("Submitted On")]),
                                          _c("b-form-datepicker", {
                                            staticClass: "mt-1",
                                            attrs: {
                                              placeholder: "Select Date",
                                              size: "sm",
                                              "date-format-options": {
                                                year: "numeric",
                                                month: "2-digit",
                                                day: "2-digit",
                                              },
                                            },
                                            on: {
                                              input: function ($event) {
                                                _vm.currentPage = 1
                                              },
                                            },
                                            model: {
                                              value: _vm.filters.date,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "date",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.date",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "cell(date)",
                                  fn: function (data) {
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.formatDateDDMMMYYYY(
                                              data.item.date
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "cell(actions)",
                                  fn: function (data) {
                                    return [
                                      _c(
                                        "b-dropdown",
                                        {
                                          staticClass: "m-1",
                                          attrs: {
                                            variant: "link",
                                            "toggle-class": "p-0",
                                            "no-caret": "",
                                            disabled:
                                              data.item.status != "PENDING",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "button-content",
                                                fn: function () {
                                                  return [
                                                    _c("feather-icon", {
                                                      staticClass:
                                                        "align-middle text-body",
                                                      attrs: {
                                                        icon: "MoreVerticalIcon",
                                                        size: "16",
                                                      },
                                                    }),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _vm.checkPermissions(data.item)
                                            ? _c(
                                                "b-dropdown-item",
                                                {
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.timesheetAction(
                                                        "APPROVED",
                                                        data.item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("feather-icon", {
                                                    attrs: {
                                                      icon: "CheckIcon",
                                                    },
                                                  }),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "align-middle ml-50",
                                                    },
                                                    [_vm._v("Approve")]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.checkPermissions(data.item)
                                            ? _c(
                                                "b-dropdown-item",
                                                {
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.timesheetAction(
                                                        "REJECTED",
                                                        data.item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("feather-icon", {
                                                    attrs: { icon: "XIcon" },
                                                  }),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "align-middle ml-50",
                                                    },
                                                    [_vm._v("Reject")]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3508802376
                            ),
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-pagination", {
                        staticClass: "mt-2",
                        attrs: {
                          "total-rows": _vm.totalRows,
                          "per-page": _vm.perPage,
                          align: "center",
                          size: "sm",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                      _c("b-form-group", [
                        _vm._v(
                          " Showing " +
                            _vm._s(
                              _vm.totalRows > 0
                                ? _vm.perPage * (_vm.currentPage - 1) + 1
                                : 0
                            ) +
                            " to " +
                            _vm._s(
                              _vm.totalRows > 0
                                ? Math.min(
                                    _vm.perPage * _vm.currentPage,
                                    _vm.totalRows
                                  )
                                : 0
                            ) +
                            " of " +
                            _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                            " entries "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }